import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import { ConfigState } from '../reducers/config.reducers';
import { AppConfigDto } from '@shared/models/app-config-dto';

const configsFeatureSelector = createFeatureSelector<ConfigState>('config');

export const selectAppConfig = createSelector(
    configsFeatureSelector,
    (state) => state?.appConfig || new AppConfigDto()
);

export const selectConfiguration = createSelector(
    configsFeatureSelector,
    ({ configuration }) => configuration
);

export const selectConfigEuLoginRegisterUrl = createSelector(
    selectAppConfig,
    ({ euLoginRegisterUrl }) => euLoginRegisterUrl
);

export const selectConfigRegDocUrl = createSelector(
    selectAppConfig,
    ({ regDocUrl }) => regDocUrl
);

export const selectConfigEuLoginAccountEditUrl = createSelector(
    selectAppConfig,
    ({ euloginAccountEditUrl }) => euloginAccountEditUrl
);

export const selectConfigMaintenanceRedirectionUrl = createSelector(
    selectAppConfig,
    ({ maintenanceRedirectionUrl }) => maintenanceRedirectionUrl
);

export const selectConfigurationRequestsMaxFileSize = createSelector(
    selectConfiguration,
    ({ requestsMaxFileSize }) => requestsMaxFileSize
);

export const selectConfigurationRequestsMaxFileSizeAllDocuments = createSelector(
    selectConfiguration,
    ({ requestsMaxFileSizeAllDocuments }) => requestsMaxFileSizeAllDocuments
);

export const selectConfigurationMaintenance = createSelector(
    selectConfiguration,
    ({ maintenanceStartDatetime, maintenanceEndDatetime, serverTimezone }) => ({
        maintenanceStartDatetime, maintenanceEndDatetime, serverTimezone
    })
);
